import React from "react";
import './common_css.css'


const TechSupportCard = ({ id, title,overall, stats, onTiClick, onCardClick }) => {
  // Normalize stats: if it's an object, convert it into an array
  const normalizedStats = Array.isArray(stats)
    ? stats
    : [
      { label: "Open", value: stats?.open ?? 0, color: "#6929E2" },
      { label: "Progress", value: stats?.progress ?? 0, color: "#A677FF" },
      { label: "Hold", value: stats?.hold ?? 0, color: "#CCACE6" },
      { label: "Closed", value: stats?.closed ?? 0, color: "#CBAFFF" },
      { label: "Completed", value: stats?.completed ?? 0, color: "#E4D6FF" },

    ];
  const firstRow = normalizedStats.slice(0, 3); // 3 cards
  const secondRow = normalizedStats.slice(3);
  return (
    <div className="tech-card">
      <div className="tech-title"
        style={{ cursor: 'pointer' }}
        onClick={() => onTiClick && onTiClick(id)}
     
      >{title} ({overall})</div>
      <div className="d-flex flex-row">
        <div className="tech-grid grid-3">
          {firstRow.map((item, index) => (
            <div
              key={index}
              className="tech-box"
              onClick={() => onCardClick?.(item.label)}
            >
              <div className="tech-label">
                <span className="dot" style={{ backgroundColor: item.color }}></span>
                {item.label}
              </div>
              <div className="tech-value">{item.value}</div>
            </div>
          ))}
        </div>

        {/* ⭐ Row 2 (2 cards) */}


      </div>
      <div className="tech-grid-dis  mt-2">
        {secondRow.map((item, index) => (
          <div
            key={index}
            className="tech-box"
            onClick={() => onCardClick?.(item.label)}
          >
            <div className="tech-label">
              <span className="dot" style={{ backgroundColor: item.color }}></span>
              {item.label}
            </div>
            <div className="tech-value">{item.value}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TechSupportCard;

